import { Loader } from '../loader'

import c from './full-loader.module.scss'

export const FullLoader = () => (
    <div className={c.component}>
        <Loader />
    </div>
)
